import styles from '@/components/app/upgrade/upgrade-view.module.css';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Table } from 'antd';

function UpgradeTable({ plans, billingCycle }) {
   const [freePlan] = (plans ?? []).filter((plan) => {
      return plan.name === 'Free';
   });
   const [proPlan] = (plans ?? []).filter((plan) => {
      return plan.name === 'pro' && plan.billingType === billingCycle;
   });
   const [advancedPlan] = (plans ?? []).filter((plan) => {
      return plan.name === 'advanced' && plan.billingType === billingCycle;
   });
   const dataSource = [
      {
         key: '1',
         name: 'AI Image Generation',
         free: (
            <>
               {freePlan?.features?.aiImageRequestLimit}
               <span className={styles.suffix}> Images</span>
            </>
         ),
         pro: (
            <>
               {proPlan?.features?.aiImageRequestLimit}
               <span className={styles.suffix}> Images</span>
            </>
         ),
         advanced: (
            <>
               {advancedPlan?.features?.aiImageRequestLimit}
               <span className={styles.suffix}> Images</span>
            </>
         ),
      },
      {
         key: '2',
         name: 'AI Text Generation',
         free: (
            <>
               {freePlan?.features?.aiRequestLimit}
               <span className={styles.suffix}> Requests</span>
            </>
         ),
         pro: (
            <>
               {proPlan?.features?.aiRequestLimit}
               <span className={styles.suffix}> Requests</span>
            </>
         ),
         advanced: (
            <>
               {advancedPlan?.features?.aiRequestLimit}
               <span className={styles.suffix}> Requests</span>
            </>
         ),
      },
      {
         key: '3',
         name: 'Downloads Per Month',
         free: freePlan?.features?.downloadLimit,
         pro: parseInt(proPlan?.features?.downloadLimit) > 1000 ? 'unlimited' : proPlan?.features?.downloadLimit,
         advanced:
            parseInt(advancedPlan?.features?.downloadLimit) > 1000
               ? 'unlimited'
               : advancedPlan?.features?.downloadLimit,
      },
      {
         key: '4',
         name: 'Brand Kit',
         free: freePlan?.features?.brandKit ? <CheckOutlined /> : <CloseOutlined />,
         pro: proPlan?.features?.brandKit ? <CheckOutlined /> : <CloseOutlined />,
         advanced: advancedPlan?.features?.brandKit ? <CheckOutlined /> : <CloseOutlined />,
      },
      {
         key: '5',
         name: 'Max Number Of Brands',
         free: freePlan?.features?.maxBrands,
         pro: parseInt(proPlan?.features?.maxBrands) === 0 ? 'unlimited' : proPlan?.features?.maxBrands,
         advanced: parseInt(advancedPlan?.features?.maxBrands) === 0 ? 'unlimited' : advancedPlan?.features?.maxBrands,
      },
      {
         key: '6',
         name: 'User Library',
         free: freePlan?.features?.library ? <CheckOutlined /> : <CloseOutlined />,
         pro: proPlan?.features?.library ? <CheckOutlined /> : <CloseOutlined />,
         advanced: advancedPlan?.features?.library ? <CheckOutlined /> : <CloseOutlined />,
      },
      {
         key: '7',
         name: 'Max Storage',
         free:
            freePlan?.features?.maxStorageSize >= 1000
               ? freePlan?.features?.maxStorageSize / 1000 + ' GB'
               : freePlan?.features?.maxStorageSize + ' MB',
         pro:
            proPlan?.features?.maxStorageSize >= 1000
               ? proPlan?.features?.maxStorageSize / 1000 + ' GB'
               : proPlan?.features?.maxStorageSize + ' MB',
         advanced:
            advancedPlan?.features?.maxStorageSize >= 1000
               ? advancedPlan?.features?.maxStorageSize / 1000 + ' GB'
               : advancedPlan?.features?.maxStorageSize + ' MB',
      },
      {
         key: '8',
         name: 'Max Upload Size',
         free:
            freePlan?.features?.maxUploadSize >= 1000
               ? freePlan?.features?.maxUploadSize / 1000 + ' GB'
               : freePlan?.features?.maxUploadSize + ' MB',
         pro:
            proPlan?.features?.maxUploadSize >= 1000
               ? proPlan?.features?.maxUploadSize / 1000 + ' GB'
               : proPlan?.features?.maxUploadSize + ' MB',
         advanced:
            advancedPlan?.features?.maxUploadSize >= 1000
               ? advancedPlan?.features?.maxUploadSize / 1000 + ' GB'
               : advancedPlan?.features?.maxUploadSize + ' MB',
      },
   ];

   const columns = [
      {
         title: (
            <span
               style={{
                  fontSize: '18px',
               }}
            >
               Features
            </span>
         ),
         dataIndex: 'name',
         key: 'name',
      },
      {
         title: (
            <span
               style={{
                  color: '#336AEA',
                  fontSize: '18px',
               }}
            >
               Free
            </span>
         ),
         dataIndex: 'free',
         key: 'free',
      },
      {
         title: <span className={styles.gradientTextPro}>Pro</span>,
         dataIndex: 'pro',
         key: 'pro',
      },
      {
         title: <span className={styles.gradientTextAdvanced}>Advanced</span>,
         dataIndex: 'advanced',
         key: 'advanced',
      },
   ];

   return (
      <Table
         className={styles.antdTable}
         dataSource={dataSource}
         pagination={false}
         columns={columns}
         scroll={{ x: true }}
         style={{ height: '100%', width: '100%' }}
         rowClassName={(record, index) => (index % 2 === 0 ? styles.evenRow : styles.oddRow)}
         rowHoverable={false}
      />
   );
}

export default UpgradeTable;
